module.exports = __webpack_public_path__ + "fa18e8ded01ce9846c4bc60fa98890ae.svg";